import React from 'react';
import Lottie from 'lottie-react';
import loadingAnimation from '@/bucket/scripts/loading.json';

interface LoadingScreenProps {
  duration?: number;
  size?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  duration = 500,
  size = "w-64 h-64" 
}) => {
  return (
    <div className="min-h-screen w-screen flex items-center justify-center gradient-bg">
      <div className={size}>
        <Lottie animationData={loadingAnimation} loop={true} />
      </div>
    </div>
  );
};

export default LoadingScreen;